<template>
  <div
    class="tw-m-4 tw-bg-white tw-shadow-lg tw-rounded tw-px-8 tw-pt-2 tw-pb-8 tw-mb-4"
  >
    <div class="tw-flex tw-flex-start tw-justify-between">
      <p class="tw-mx-4 tw-block tw-mt-8 tw-font-bold tw-text-2xl">
        All Created Project Sectors
      </p>
      <router-link class="tw-mx-4 tw-block" to="/admin/sector/add">
        <button
          class="tw-bg-idea-light hover:tw-bg-idea-dark tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-mt-8 tw-rounded tw-inline-flex tw-items-start"
        >
          <i class="fas fa-plus tw-fill-current tw-w-4 tw-h-4 tw-m-1"></i>

          <span>Add Sector</span>
        </button>
      </router-link>
    </div>
    <table
      v-if="sectors.length > 0 && !loading"
      class="tw-block tw-table-fixed tw-mx-auto tw-text-left md:tw-mx-8"
    >
      <thead class="">
        <tr>
          <th class="tw-w-2/3 tw-px-4 tw-py-2 ">Name</th>
          <th class="tw-w-1/3 tw-px-4 tw-py-2 ">Description</th>
          <th class="tw-w-1/3 tw-px-4 tw-py-2 "></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(sector, index) in sectors"
          :key="index"
          :class="index % 2 == 0 ? 'tw-bg-gray-100' : ''"
        >
          <td class="tw-border tw-w-2/3 tw-px-4 tw-py-2">{{ sector.name }}</td>
          <td class="tw-border tw-w-2/3 tw-px-4 tw-py-2">
            {{ sector.description }}
          </td>
          <td class="tw-border tw-w-1/3 tw-px-4 tw-py-2">
            <!-- <span class="tw-mx-2" @click="setUpdate(sector)">
              <i class="far fa-edit"></i>
            </span> -->
            <span class="text-red-500 tw-mx-2">
              <i class="fas fa-trash-alt" @click="deleteSector(sector._id)"></i
            ></span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="tw-mt-12">
      <!-- <img class="my-img" src="../../assets/img/empty.svg" /> -->
      <p>No sector created yet</p>
    </div>
    <vue-element-loading
      v-if="loading"
      :active="loading"
      :is-full-screen="true"
    />

    <!-- Add Modal -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <p class="tw-mx-4 tw-block tw-mt-8 tw-font-bold tw-text-2xl">
              Add Status
            </p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="tw-w-full md:tw-w-1/2 tw-mx-auto">
                <form class="">
                  <div class="tw-mb-4">
                    <label
                      class="tw-block tw-text-gray-700 tw-text-left tw-text-sm tw-font-bold tw-mb-2"
                      for="name"
                      >Name</label
                    >
                    <input
                      class="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      id="name"
                      type="text"
                      placeholder="Stage 2"
                      v-model="data.name"
                    />
                    <p v-if="errors.name" class="tw-text-xs tw-text-red-500">
                      Please name of sector.
                    </p>
                  </div>
                  <div class="tw-mb-4">
                    <label
                      class="tw-block tw-text-gray-700 tw-text-left tw-text-sm tw-font-bold tw-mb-2"
                      for="name"
                      >Description</label
                    >
                    <input
                      class="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      id="name"
                      type="text"
                      placeholder="Stage 2"
                      v-model="data.description"
                    />
                    <p
                      v-if="errors.description"
                      class="tw-text-xs tw-text-red-500"
                    >
                      Please description of sector.
                    </p>
                  </div>
                  <vue-element-loading
                    v-if="loading"
                    :active="loading"
                    :is-full-screen="true"
                  />
                </form>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Close</v-btn
            >
            <v-btn color="#2C316C" text @click="submit()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <p
      @click="dialog = true"
      to="/user/project/add/initial"
      class="add-btn tw-bg-eko-dark tw-text-white tw-cursor-pointer"
    >
      +
    </p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      user: {},
      error: false,
      loading: true,
      token: "",
      sectors: [],
      dialog: false,
      data: {},
      errors: {},
      edit: {}
    };
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.getSectors();
  },
  methods: {
    getSectors() {
      const self = this;
      axios
        .get(`${this.$baseUrl}/sector/get`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          }
        })
        .then(response => {
          console.log(response.data);
          this.sectors = response.data.sectors;
          self.loading = false;
          self.success = true;
        })
        .catch(error => {
          self.loading = false;
          self.error = true;
          console.log(error);
        });
    },
    deleteSector(id) {
      const self = this;
      this.loading = true;
      axios
        .delete(`${this.$baseUrl}/sector/delete/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          }
        })
        .then(response => {
          this.getSectors();
          console.log(response);
          self.loading = false;
          self.success = true;
        })
        .catch(error => {
          self.loading = false;
          self.error = true;
          console.log(error);
        });
    },
    submit() {
      this.error = false;
      this.error_msg = "";
      this.loading = false;
      this.success = false;
      this.success_msg = "";
      this.errors = {};
      let deny = false;
      if (!this.data.name) {
        this.errors.name = true;
        deny = true;
      }
      if (!this.data.description) {
        this.errors.description = true;
        deny = true;
      }
      if (deny) {
        return;
      }
      const self = this;
      self.loading = true;
      axios
        .post(`${this.$baseUrl}/sector/create`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          }
        })
        .then(response => {
          console.log(response);
          self.loading = false;
          self.success = true;
          self.$swal("Success!", "Sector created successfully", "success");
          this.data = {};
          this.edit = {};
          this.getSectors();
          this.dialog = false;
        })
        .catch(error => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    }
  }
};
</script>

<style lang="css" scoped>
.add-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  font-size: 36px;
}
.my-img {
  width: 50%;
  height: 50%;
  margin: auto;
}
</style>
